import { colors } from '@styleseat/brand';
import analytics from '../../../../../modules/analytics';
import { CARD_TYPES } from '../../Components/InsightCards/cards/InsightCardFactory';
import stateManager from '../../../../../modules/user/stateManager';
import {
  InsightCardFactoryProps,
  InsightCardProps,
} from '../../Components/InsightCards/types';
import { postProviderInsightAction } from '../../../../../modules/Api';
import {
  INSIGHT_ACTIONS,
  INSIGHT_ACTION_PREFIX,
  MARKETING_TIPS_ACTIONS,
} from '../../../MarketingUtils/constants';
import { InsightModel } from '../types';
import { SITE_ROOT } from '../../../../../config';

const ACTION_PREFIX = `${INSIGHT_ACTION_PREFIX}invite-client-to-book`;
const INVITE_CLIENTS_TO_BOOK_ID = 'invite-clients-to-book-insight';
const INVITE_CLIENTS_TO_BOOK_ANALYTICS_BASE_ID = 'pro_home_invite_client_to_book';

/**
 * parseCardData - parse data it into InsightCardProps
 * and return the results
 *
 * @param provider The provider details.
 * @param insightId The insight's id.
 * @param updateInsights Method from parent component to handle actions.
 * @returns : InsightCardProps
 */
const parseCardData = (
  provider,
  insightId,
  updateInsights,
  cardIndex,
): InsightCardProps => ({
  id: INVITE_CLIENTS_TO_BOOK_ID,
  headline: 'Invite your clients to book online',
  headlineColor: colors.blackInBlack,
  bodyText: [
    {
      text:
        'Clients prefer booking online. Using your shared link insures you recieve 100% of the booking,',
    },
    {
      text: 'cancellation protection and free up your day.',
    },
  ],
  cta: 'copy link',
  analyticsData: {
    event: `${INVITE_CLIENTS_TO_BOOK_ANALYTICS_BASE_ID}_grow_click`,
    payload: {
      providerId: provider.id,
    },
  },
  dismissParams: {
    analyticsDismissData: {
      event: `${INVITE_CLIENTS_TO_BOOK_ANALYTICS_BASE_ID}_grow_dismiss`,
      payload: {
        providerId: provider.id,
      },
    },
    onDismiss: () => {
      postProviderInsightAction(
        provider.id,
        insightId,
        INSIGHT_ACTIONS.DISMISS_CLICKED,
      );
      updateInsights({
        type: MARKETING_TIPS_ACTIONS.dismiss,
        cardId: INVITE_CLIENTS_TO_BOOK_ID,
      });
    },
    dismissText: 'No thanks',
  },
  firstViewTracking: () => analytics.track(`${INVITE_CLIENTS_TO_BOOK_ANALYTICS_BASE_ID}_grow_view`, {
    card_index: cardIndex,
  }),
  onAction: async () => {
    postProviderInsightAction(
      provider.id,
      insightId,
      INSIGHT_ACTIONS.CTA_CLICKED,
    );
    updateInsights({
      type: MARKETING_TIPS_ACTIONS.cta,
      cardId: INVITE_CLIENTS_TO_BOOK_ID,
    });
  },
  timeToComplete: '2 minutes',
  metadata: {
    copy_link: `${SITE_ROOT}/${provider.vanity_url}`,
  },
});

export const getInsights = async (): Promise<InsightModel> => {
  try {
    const inviteClientToBookAction = await stateManager.getActionValue(
      `${ACTION_PREFIX}complete`,
    );
    return inviteClientToBookAction
      ? null
      : {
        insight_type: 'inviteClientsToBook',
      };
  } catch (error) {
    return null;
  }
};

export const parseInviteClientsToBookInsight = (
  provider,
  insight,
  updateInsights,
  user,
  metrics,
  cardIndex,
): InsightCardFactoryProps => ({
  type: CARD_TYPES.inlineHeadlineWithCopyCta,
  cardProps: parseCardData(provider, insight.id, updateInsights, cardIndex),
});
